import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { MOBILE_HEIGHT } from 'base/lib/banners'
import { VelocityTransitionGroup } from 'velocity-react'
import Banner from 'base/components/layout/banners/banner_from_config'

const DESKTOP_BANNER_HEIGHT = 45

function SessionMessagingBanner({ message, platform }) {
  return (
    <VelocityTransitionGroup
      enter={{
        animation: 'transition.slideDownIn',
        duration: 350,
      }}
      leave={{
        animation: 'transition.fadeOut',
        duration: 450,
      }}
    >
      {message && (
        <div
          style={{
            minHeight: platform === 'desktop' ? DESKTOP_BANNER_HEIGHT : MOBILE_HEIGHT,
          }}
        >
          <Banner
            className="banner__session-message-container"
            inheritBannerStyles={false}
            height={platform === 'desktop' ? DESKTOP_BANNER_HEIGHT : MOBILE_HEIGHT}
          >
            <p className="banner__session-message">{message}</p>
          </Banner>
        </div>
      )}
    </VelocityTransitionGroup>
  )
}

function mapStateToProps(state) {
  return {
    message: state.session.messaging.message,
    isError: state.session.messaging.error,
  }
}

SessionMessagingBanner.propTypes = {
  message: PropTypes.string,
  platform: PropTypes.string,
}

export default connect(mapStateToProps)(SessionMessagingBanner)
